export { CardMarketEntityMobile } from './card-market';
